module.exports = __webpack_public_path__ + "img/banner3.7871ef58.png";